// catalog namespace: CatalogPage.vue and components/catalog/*
export default {
  en: {
    breadcrumb: {
      catalog: 'Catalog',
    },
    heading: 'Browse games',
    searchPlaceholder: 'Search games…',
    searchAriaLabel: 'Search games',
    filters: {
      title: 'Filters',
      open: 'Filters ({count})',
      showResults: 'Show {count} games',
      showMore: 'Show {count} more',
      showLess: 'Show less',
      platform: 'Platform',
      genre: 'Genre',
      price: 'Price',
      region: 'Region',
      ageRating: 'Age rating',
      availability: 'Availability',
      inStockOnly: 'In stock only',
      priceMinLabel: 'Min €',
      priceMaxLabel: 'Max €',
      priceMinAriaLabel: 'Minimum price',
      priceMaxAriaLabel: 'Maximum price',
    },
    chips: {
      label: 'Active filters',
      remove: 'Remove filter: {label}',
      clearAll: 'Clear all',
      search: '“{query}”',
      priceRange: '{min} – {max} €',
      priceFrom: 'From {min} €',
      priceUpTo: 'Up to {max} €',
      withOutOfStock: 'Including out of stock',
    },
    results: {
      count: '{count} game | {count} games',
    },
    sort: {
      label: 'Sort by',
      popular: 'Popularity',
      newest: 'Newest',
      priceAsc: 'Price: low to high',
      priceDesc: 'Price: high to low',
      nameAsc: 'Name: A–Z',
    },
    density: {
      label: 'Grid density',
      comfortable: 'Comfortable grid',
      compact: 'Compact grid',
    },
    error: 'We could not load the catalog. Check your connection and try again.',
    empty: 'No games match your filters.',
    emptyPlatforms: 'Or jump straight to a platform',
    clearFilters: 'Clear filters',
    browseDeals: 'Browse deals',
    quickView: {
      label: 'Quick view',
      fullDetails: 'Full details',
      notFound: 'This product is no longer in the catalog',
    },
    pagination: {
      previous: 'Previous',
      next: 'Next',
      goTo: 'Page {page}',
      ariaLabel: 'Pagination',
    },
  },
  cs: {
    breadcrumb: {
      catalog: 'Katalog',
    },
    heading: 'Procházet hry',
    searchPlaceholder: 'Hledat hry…',
    searchAriaLabel: 'Hledat hry',
    filters: {
      title: 'Filtry',
      open: 'Filtry ({count})',
      showResults: 'Zobrazit {count} her',
      showMore: 'Zobrazit dalších {count}',
      showLess: 'Zobrazit méně',
      platform: 'Platforma',
      genre: 'Žánr',
      price: 'Cena',
      region: 'Region',
      ageRating: 'Věkové hodnocení',
      availability: 'Dostupnost',
      inStockOnly: 'Pouze skladem',
      priceMinLabel: 'Min €',
      priceMaxLabel: 'Max €',
      priceMinAriaLabel: 'Minimální cena',
      priceMaxAriaLabel: 'Maximální cena',
    },
    chips: {
      label: 'Aktivní filtry',
      remove: 'Odebrat filtr: {label}',
      clearAll: 'Vymazat vše',
      search: '„{query}“',
      priceRange: '{min} – {max} €',
      priceFrom: 'Od {min} €',
      priceUpTo: 'Do {max} €',
      withOutOfStock: 'Včetně nedostupných',
    },
    results: {
      count: '{count} hra | {count} hry | {count} her',
    },
    sort: {
      label: 'Řadit podle',
      popular: 'Popularita',
      newest: 'Nejnovější',
      priceAsc: 'Cena: od nejnižší',
      priceDesc: 'Cena: od nejvyšší',
      nameAsc: 'Název: A–Z',
    },
    density: {
      label: 'Hustota mřížky',
      comfortable: 'Pohodlná mřížka',
      compact: 'Kompaktní mřížka',
    },
    error: 'Katalog se nepodařilo načíst. Zkontrolujte připojení a zkuste to znovu.',
    empty: 'Žádné hry neodpovídají vašim filtrům.',
    emptyPlatforms: 'Nebo přejděte rovnou na platformu',
    clearFilters: 'Vymazat filtry',
    browseDeals: 'Prohlédnout slevy',
    quickView: {
      label: 'Rychlý náhled',
      fullDetails: 'Všechny podrobnosti',
      notFound: 'Tento produkt už v katalogu není',
    },
    pagination: {
      previous: 'Předchozí',
      next: 'Další',
      goTo: 'Stránka {page}',
      ariaLabel: 'Stránkování',
    },
  },
};
